import { api } from "@/api";

export interface KudeTicketItem {
  codigo: string | null;
  descripcion: string | null;
  cantidad: number | null;
  precio: number | null;
}

export interface KudeTicketTransporte {
  tipoTransporte: string | null;
  inicioTraslado: string | null;
  finTraslado: string | null;
  vehiculo: string | null;
  numeroIdentificacionVehiculo: string | null;
  ciudadSalida: string | null;
  ciudadEntrega: string | null;
  transportista: string | null;
  rucDocTransportista: string | null;
  nombreChofer: string | null;
  docChofer: string | null;
}

export interface KudeTicketDatos {
  docLabel: string;
  iTiDE: number;
  logoBase64: string | null;

  rucEmisor: string | null;
  nombreEmisor: string | null;
  direccionEmisor: string | null;
  ciudadEmisor: string | null;
  actividadesEconomicas: string[];

  timbrado: string | null;
  inicioVigencia: string | null;
  numeroDocumento: string | null;
  fechaEmision: string;
  tipoTransaccion: string | null;
  moneda: string | null;
  condicionVenta: string | null;

  receptorNombre: string | null;
  receptorDocumento: string | null;
  receptorDireccion: string | null;
  receptorTelefono: string | null;
  clienteNombre: string | null;

  vendedorNombre: string | null;
  vendedorDocumento: string | null;

  transporte: KudeTicketTransporte | null;

  tipoDocumentoAsociado: number | null;
  cdcDocumentoAsociado: string | null;

  items: KudeTicketItem[];

  totalOperacion: number | null;
  totalGs: number | null;
  totalExento: number | null;
  iva5: number | null;
  iva10: number | null;

  cdc: string | null;
  qrBase64: string | null;
  urlConsultas: string | null;
  infoFiscal: string | null;
  cMoneOpe: string | null;
}

export interface KudeTicketDatosResponse {
  success: boolean;
  data: KudeTicketDatos;
}

export async function getVentaKudeTicketDatos(ventaId: string): Promise<KudeTicketDatosResponse> {
  const response = await api.get<KudeTicketDatosResponse>(`ventas/${ventaId}/kude-ticket-datos`);
  return response.data;
}
